import httpAdminClient from '@/plugins/httpAdminClient';

export default {
  index(currentPage, perPage, params) {
    return httpAdminClient.get('expense/admin/receipts', {
      params: {
        ...params,
        page: currentPage,
        per_page: perPage,
      },
    });
  },
  find(id) {
    return httpAdminClient.get(`expense/admin/receipts/${id}`);
  },
  // extend
  indexByFund(fundId, currentPage, perPage, params = {}) {
    return httpAdminClient.get(`expense/admin/fund_items/${fundId}/receipts`, {
      params: {
        ...params,
        page: currentPage,
        per_page: perPage,
      },
    });
  },
  indexByProject(projectId, currentPage, perPage, params = {}) {
    return httpAdminClient.get(`expense/admin/research_projects/${projectId}/receipts`, {
      params: {
        ...params,
        page: currentPage,
        per_page: perPage,
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/adminApis/research/api-receipt.js